import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import es from './locales/es.json';
import en from './locales/en.json';
import de from './locales/de.json';

const saved = (() => { try { return localStorage.getItem('colmena_lang'); } catch { return null; } })();
const browserLang = navigator.language?.slice(0, 2).toLowerCase();
const supported = ['es', 'en', 'de'];
const detected = supported.includes(browserLang) ? browserLang : 'es';

i18n
  .use(initReactI18next)
  .init({
    resources: { es: { translation: es }, en: { translation: en }, de: { translation: de } },
    lng: saved || detected,
    fallbackLng: 'es',
    interpolation: { escapeValue: false },
  });

export default i18n;
